let formModel = {
    full_name: '',
    club: '', 
    player_position:'',
    media:''
}
export default formModel;